const validatePax = (pax) => {

  let requiresAdults = false;
  let hasAdults = false;
  pax.map((entry) => {
    if (entry.adult && entry.value > 0) {
      hasAdults = true;
    }
    if (entry.requires_adult && entry.value > 0) {
      requiresAdults = true;
    }
  });

  let valid = !requiresAdults || (requiresAdults && hasAdults);

  return [
    valid,
    !valid ? 'Infants cannot travel alone.' : ''
  ];
}

export default validatePax;
